<template>
  <div class="container-fluid customer-media-container">
    <!-- home img
    <b-row>
      <b-col lg="2" md="5" cols="5" class="mx-auto">
       
      </b-col>
    </b-row> -->
    <!-- title -->
    <b-row>
      <b-col xl="9" lg="10" class="mx-auto">
        <b-row class="mt-md-4 mt-1">
          <b-col
            xl="2"
            lg="1"
            offset-lg="0"
            md="2"
            offset-md="1"
            class="text-center px-0"
          >
            <img
              class="imageTitleDY"
              src="@/assets/images/doom-yoga/doomyoga-music.png"
              alt="doomyoga Logo"
            />
          </b-col>
          <b-col
            xl="10"
            lg="11"
            md="8"
            class="d-flex align-items-center text-center"
          >
            <h2 class="welcomeUserHomeH2DY mb-0">
              Surrender to Sound and Silence
            </h2>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <AudioPlaylistPlayer
      v-if="tracks.length > 0"
      client_name="DY"
      :playlist_title="playlist_title"
      :tracks="tracks"
    />
  </div>
</template>

<script>
import AudioPlaylistPlayer from "@/components/media_components/AudioPlaylistPlayer.vue";
import axios from "axios";

export default {
  name: "DoOmYogaCustomerMusicMP3Playlist",
  components: { AudioPlaylistPlayer },
  data() {
    return {
      login_user: window.localStorage.getItem("user"),
      user_name: "",
      playlist_title: "",
      playlist_id: null,

      tracks: [],
    };
  },

  mounted() {
    this.playlist_id = this.$route.params.id;
    console.log(this.playlist_id);
    // this.selected_category = [Number(this.$route.params.id)];
    this.getAudiosRequest();
  },
  methods: {
    getAudiosRequest() {
      axios
        .get("/media/library/category/" + this.playlist_id, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            client: "DY",
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          console.log(response);
          console.log(response.data.library_media);
          console.log(response.data.library_media.length);
          this.playlist_title = response.data.title;
          this.tracks = response.data.library_media;

          // this.tracks = this.tracks.concat(this.tracks);
          // this.tracks = this.tracks.concat(this.tracks);
        });
    },
  },
};
</script>
<style scoped::v-deep >
@import "../../css/doom-yoga-audio-player-styles.css";
</style>


// WEBPACK FOOTER //
// src/components/doom_yoga/customer/Music/AudiosList.vue